import { render, staticRenderFns } from "./VR.vue?vue&type=template&id=146e0bfe&scoped=true&"
import script from "./VR.vue?vue&type=script&lang=js&"
export * from "./VR.vue?vue&type=script&lang=js&"
import style0 from "./VR.vue?vue&type=style&index=0&id=146e0bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e0bfe",
  null
  
)

export default component.exports